import React, { useState, useCallback } from 'react';
import getMonth from 'date-fns/getMonth';
import lightFormat from 'date-fns/lightFormat';
import { DateRangePicker } from 'react-date-range';
import { FAIcon } from 'preferral-ui/components/FAIcon';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './DateRangeDropdown.css';

// interface DateRangeDropdownProps {
//   value: TimeRange;
//   onChange(timeRange: TimeRange): void;
// }

export const DateRangeDropdown = (props) => {
  const { value, onChange } = props;
  const { start, finish } = value;

  const propRange = {
    startDate: start,
    endDate: finish,
  };

  const [isOpen, setIsOpen] = useState(false);
  const close = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const [selectedRange, setSelectedRange] = useState(propRange);

  const handleApply = useCallback(() => {
    onChange({
      start: selectedRange.startDate,
      finish: selectedRange.endDate,
    });
    close();
  }, [selectedRange, onChange, close]);

  const handleCancel = useCallback(() => {
    setSelectedRange(propRange);
    close();
  }, [propRange, close]);

  return (
    <div className="DateRangeDropdown">
      <div className="DateRangeDropdown__container">
        <div
          className="DateRangeDropdown__trigger"
          onClick={() => (isOpen ? setIsOpen(false) : setIsOpen(true))}
        >
          <div className="DateRangeDropdown__trigger__date">
            {formatDate(start)}
          </div>
          <div className="DateRangeDropdown__trigger__date-divider">
            <FAIcon icon="arrow-right" />
          </div>
          <div className="DateRangeDropdown__trigger__date">
            {formatDate(finish)}
          </div>
          <div className="DateRangeDropdown__trigger__chevron">
            <FAIcon icon="chevron-down" />
          </div>
        </div>
        <div
          className={`DateRangeDropdown__content ${
            isOpen
              ? 'DateRangeDropdown__content--open'
              : 'DateRangeDropdown__content--closed'
          }`}
        >
          <div className="DateRangeDropdown__content__body">
            <DateRangePicker
              ranges={[{ ...selectedRange, key: 'selection' }]}
              onChange={(e) => setSelectedRange(e.selection)}
              twoStepChange={false}
            />
          </div>
          <div className="DateRangeDropdown__content__footer">
            <button type="button" onClick={handleCancel} className="btn">
              Cancel
            </button>
            <button
              type="button"
              onClick={handleApply}
              className="btn btn-primary"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function formatDate(date) {
  return `${monthStr(date)} ${lightFormat(date, 'd, yyyy')}`;
}

const monthStrings = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

function monthStr(date) {
  return monthStrings[getMonth(date)];
}
